export default "__VITE_ASSET__DLmiYMVK__"